// =====================================================================
// «ENTRA CON UN TOQUE LA PRÓXIMA VEZ» · DIRECTRIZ-LLAVE L-3 (R-LL-4)
// =====================================================================
// Después de entrar con contraseña (y código), a quien todavía no tiene
// ninguna llave y usa un navegador que las admite se le ofrece crear una.
// Es una tarjeta, no una pantalla: no interrumpe el trabajo y se cierra.
//
// «Ahora no» la cierra PARA SIEMPRE para esa persona en este navegador
// (decisión R-LL-4). «Agregar mi llave» lleva a Mi cuenta → Seguridad →
// Llaves de acceso, al mismo sitio que el enlace de la pantalla de
// entrada (L-2).
//
// NO SE ENSEÑA si no se pudo saber cuántas llaves tiene: ofrecer crear
// algo que quizá ya existe sería decir algo que no consta.
import { useEffect, useState } from 'react';
import { Fingerprint, X } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';
import {
  ENLACE_LLAVES, SECCION_LLAVES, apuntarSeccion, llaveYaRechazada, navegadorAdmiteLlaves, rechazarOfertaDeLlave,
} from './llaveDeAcceso';

export default function TarjetaEntraConUnToque({ idUsuario, onCerrar, irAMiCuenta }) {
  const [ver, setVer] = useState(false);

  useEffect(() => {
    if (!idUsuario || !navegadorAdmiteLlaves() || llaveYaRechazada(idUsuario)) return undefined;
    let vivo = true;
    api.get('/seguridad/llaves')
      .then((d) => {
        if (!vivo) return;
        const tiene = Array.isArray(d?.llaves) && d.llaves.length > 0;
        setVer(!tiene && d?.disponible !== false);
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, [idUsuario]);

  if (!ver) return null;

  function ahoraNo() {
    rechazarOfertaDeLlave(idUsuario);
    setVer(false);
    onCerrar?.();
  }

  // La tarjeta vive fuera de las pantallas (en la sesión, no en el
  // AppShell), así que no tiene el `irA` de la puerta de navegación y no
  // puede cambiar de módulo por su cuenta (guarda G2). Es un enlace de
  // verdad al mismo destino que el de la pantalla de entrada (L-2): la
  // página se vuelve a abrir en Mi cuenta → Llaves de acceso con la sesión
  // intacta. Quien la monta con `irAMiCuenta` (las pruebas) navega sin
  // recargar.
  function agregar(e) {
    setVer(false);
    onCerrar?.();
    if (irAMiCuenta) {
      e.preventDefault();
      apuntarSeccion(SECCION_LLAVES);
      irAMiCuenta();
    }
  }

  return (
    <aside role="region" aria-labelledby="tarjeta-un-toque-titulo" data-tarjeta="entra-con-un-toque"
           className="fixed inset-x-3 bottom-20 z-40 rounded-xl border border-gray-200 bg-white p-4 shadow-lg sm:inset-x-auto sm:right-4 sm:w-96">
      <div className="flex items-start gap-3">
        <Fingerprint className="mt-0.5 h-6 w-6 shrink-0 text-[var(--color-marca)]" aria-hidden="true" />
        <div className="min-w-0 flex-1 space-y-1">
          <h2 id="tarjeta-un-toque-titulo" className="font-semibold text-gray-900">Entra con un toque la próxima vez</h2>
          <p className="text-sm text-gray-600">Guarda una llave de acceso en este aparato y entra con tu huella, tu cara o tu PIN, sin escribir la contraseña ni el código.</p>
        </div>
      </div>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:justify-end">
        <button type="button" onClick={ahoraNo} data-accion="ahora-no"
                className="inline-flex min-h-11 items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">
          <X className="h-4 w-4" aria-hidden="true" /> Ahora no
        </button>
        <a href={ENLACE_LLAVES} onClick={agregar} data-accion="agregar-mi-llave"
           className="inline-flex min-h-11 items-center justify-center gap-1.5 rounded-lg bg-[var(--color-marca)] px-4 py-2 text-sm font-semibold text-white">
          <Fingerprint className="h-4 w-4" aria-hidden="true" /> Agregar mi llave
        </a>
      </div>
      <Ayuda id="seguridad.llaves.oferta" />
    </aside>
  );
}
